import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Content } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update Course Text content
 * @param course_id
 * @param version
 * @param contentId
 * @param content
 */
const updateCourseTextContent = (
  course_id: string,
  version: number,
  contentId: string,
  content: {}
): Promise<Content> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/text/' + contentId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { lecture_content: content }

    AxiosClient.patch(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourseTextContent
